import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { OAuthModule } from 'angular-oauth2-oidc';

import { LightboxModule } from '@gosuite/lightbox';
import { ButtonModule } from '@gosuite/button';
import { BarLoaderModule } from '@gosuite/preloader';
import { SelectModule } from '@gosuite/selects';
import { FormsModule } from '@angular/forms';

import { PrrlFormButlerDialogComponent } from './prrl-form-butler-dialog.component';
import { PrrlFormButlerTokenService } from './prrl-form-butler-token.service';



@NgModule({
	declarations: [ PrrlFormButlerDialogComponent ],
	entryComponents: [ PrrlFormButlerDialogComponent ],
	exports: [ PrrlFormButlerDialogComponent ],
	imports: [
		CommonModule,
		LightboxModule,
		ButtonModule,
		OAuthModule,
		BarLoaderModule,
		SelectModule,
		FormsModule,
	],
	providers: [
		PrrlFormButlerTokenService,
	]
})
export class PrrlFormButlerDialogModule {}



// WEBPACK FOOTER //
// ./src/app/shared/components/prrl-form-butler-dialog/prrl-form-butler-dialog.module.ts